import { ArrowDownwardRounded, ArrowUpwardRounded } from "@mui/icons-material";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { IssuesSortByOption, SortByDirection } from "../../constants";

interface Props {
  sortByOption: IssuesSortByOption;
  sortByDirection: SortByDirection;
  onSortByChanged: (value: IssuesSortByOption) => void;
  onSortDirectionChanged: (value: SortByDirection) => void;
}

const IssuesSortToggleButton = (props: Props) => {
  function handleSortByChanged(value: IssuesSortByOption) {
    if (value != null) {
      props.onSortByChanged(value);
    }
  }

  function handleSortDirectionChanged() {
    if (props.sortByDirection === SortByDirection.Ascending) {
      props.onSortDirectionChanged(SortByDirection.Descending);
    } else {
      props.onSortDirectionChanged(SortByDirection.Ascending);
    }
  }

  return (
    <ToggleButtonGroup
      value={props.sortByOption}
      exclusive
      orientation="vertical"
      variant="menu"
      onChange={(_, value) => handleSortByChanged(value)}
      sx={{ minWidth: "100%" }}
    >
      <ToggleButton
        value={IssuesSortByOption.DateCreated}
        onClick={handleSortDirectionChanged}
        sx={{ justifyContent: "space-between !important" }}
      >
        <Typography>Date Created</Typography>
        {props.sortByOption === IssuesSortByOption.DateCreated ? (
          props.sortByDirection === SortByDirection.Descending ? (
            <ArrowDownwardRounded />
          ) : (
            <ArrowUpwardRounded />
          )
        ) : null}
      </ToggleButton>
      <ToggleButton
        value={IssuesSortByOption.DateModified}
        onClick={handleSortDirectionChanged}
        sx={{ justifyContent: "space-between !important" }}
      >
        <Typography>Date Modified</Typography>
        {props.sortByOption === IssuesSortByOption.DateModified ? (
          props.sortByDirection === SortByDirection.Descending ? (
            <ArrowDownwardRounded />
          ) : (
            <ArrowUpwardRounded />
          )
        ) : null}
      </ToggleButton>
      <ToggleButton
        value={IssuesSortByOption.Name}
        onClick={handleSortDirectionChanged}
        sx={{ justifyContent: "space-between !important" }}
      >
        <Typography>Name</Typography>
        {props.sortByOption === IssuesSortByOption.Name ? (
          props.sortByDirection === SortByDirection.Descending ? (
            <ArrowDownwardRounded />
          ) : (
            <ArrowUpwardRounded />
          )
        ) : null}
      </ToggleButton>
      <ToggleButton
        value={IssuesSortByOption.Upvotes}
        onClick={handleSortDirectionChanged}
        sx={{ justifyContent: "space-between !important" }}
      >
        <Typography>Upvotes</Typography>
        {props.sortByOption === IssuesSortByOption.Upvotes ? (
          props.sortByDirection === SortByDirection.Descending ? (
            <ArrowDownwardRounded />
          ) : (
            <ArrowUpwardRounded />
          )
        ) : null}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export { IssuesSortToggleButton };
